const WIDGET_DEFAULT = {
  HEADING: 'Chat with us',
  SELECTED_COLOR: '#58A5FF',
  TAGLINE: 'Ask us anything or share your feedback',
  WELCOME_MESSAGE: 'Hi there! How can I help you today?',
};

const WIDGET_LEGEND = {
  IMG_PICKER: 'Image size of 250x250 is recommended.',
  WELCOME_MESSAGE: 'Send an automated response to visitors when they initiate a new chat',
};

const WIDGET_EDIT_ROUTE_PATH = '/chat/edit/';

const CHAT_SETTINGS_DEFAULT_PAYLOAD = {
  channelAdminValue: {
    state : {
      chat_settings: {},
    },
  }
};

const ERROR_MESSAGE = {
  LOGO_SIZE_EXCEEDED: 'Choose an image less than 10 MB',
  MONO_TEXTBOX_CHAR: 'Must be 30 characters or less',
  MULTI_TEXTBOX_CHAR: 'Must be 200 characters or less',
};

const INPUT_CONFIG = {
  HEADING: {
    MIN: 1,
    MAX: 30,
    ERROR: ERROR_MESSAGE.MONO_TEXTBOX_CHAR,
  },
  TAGLINE: {
    MIN: 0,
    MAX: 200,
    ERROR: ERROR_MESSAGE.MULTI_TEXTBOX_CHAR,
  },
  WELCOME_MESSAGE: {
    MIN: 0,
    MAX: 200,
    ERROR: ERROR_MESSAGE.MULTI_TEXTBOX_CHAR,
  },
};

const DEFAULT_ERROR = {
  isError: false,
  errorText: '',
};

const LEGEND_CSAT = 'Show CSAT (Customer satisfaction) survey to the visitor after the chat is closed';

const WIDGET_DISPLAY_LEGEND = {
  BEFORE: 'Your website visitors see this before they initiate a chat',
  AFTER: 'Your website visitors see this after they have initiated a chat',
};

const DISABLED_TOOLTIP = 'This field is disabled as a chatbot flow is already active';

const WELCOME_MESSAGE = "Welcome message"

const BOT_CONFIGURATION_ROUTE = "botConfiguration"

export {
  WIDGET_DEFAULT,
  WIDGET_LEGEND,
  WIDGET_EDIT_ROUTE_PATH,
  CHAT_SETTINGS_DEFAULT_PAYLOAD,
  INPUT_CONFIG,
  DEFAULT_ERROR,
  LEGEND_CSAT,
  WIDGET_DISPLAY_LEGEND,
  DISABLED_TOOLTIP,
  WELCOME_MESSAGE,
  BOT_CONFIGURATION_ROUTE,
};
